import { ExceptionHandler } from '@hook/exceptionHandlers/exceptionHandler';
import useRouting from '@hook/useRouting';
import { AxiosError } from 'axios';
import { useCallback } from 'react';
import { toast } from 'react-toastify';

export const useSpaceQueryExceptionHandler = (): ExceptionHandler => {
  const routing = useRouting();
  return useCallback((error: unknown) => {
    if (!(error instanceof AxiosError)) return true;
    if (error?.response?.status === 401) routing.navigate(routing.welcome.getPath());
    if (error?.response?.status === 403) routing.navigate(routing.forbidden.getPath());

    if (error?.response?.status === 409) {
      toast(error.message, { type: 'error' });
    }
    return false;
  }, []);
};
